import { Box, Typography } from '@mui/material';

import { FORTA_BLUE } from '../../../../utils/colors';
import TableSortIcon from '../../../svgs/TableSortIcon';
import { history } from '../../../../helpers';
import { formatSessionId, getNavigateUrlForProcedures } from '../claims/utils';

import type { Responsive, SelectableRows } from 'mui-datatables';

export const sessionsInClaimTableOptions = {
  filter: false,
  print: false,
  search: false,
  viewColumns: false,
  pagination: false,
  fixedHeader: false,
  sort: true,
  download: false,
  responsive: 'standard' satisfies Responsive,
  selectableRows: 'none' satisfies SelectableRows,
  tableBodyHeight: '100%',
  textLabels: {
    body: {
      noMatch: 'Loading',
    },
  },
};

export const sessionsInClaimColDefs = [
  {
    name: 'service_code',
    label: 'Service code',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'date',
    label: 'Date',
    options: {
      filter: false,
      sort: true,
      customHeadLabelRender: () => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            color={FORTA_BLUE.primary}
            sx={{ mr: 1, fontWeight: '700', fontSize: '16px', lineHeight: '24px' }}
          >
            Date
          </Typography>
          <TableSortIcon />
        </Box>
      ),
    },
  },
  {
    name: 'id',
    label: 'Session ID',
    options: {
      filter: false,
      sort: true,
      customBodyRender: (value: string, tableMeta: any) => {
        const { rowData } = tableMeta;
        const [code, _date, id] = rowData;
        return (
          <Typography
            sx={{ '&:hover': { cursor: 'pointer' }, textDecoration: 'underline' }}
            color={FORTA_BLUE.primary}
            onClick={() => {
              history.navigate(getNavigateUrlForProcedures(code, id));
            }}
          >
            {formatSessionId(code, id)}
          </Typography>
        );
      },
      customHeadLabelRender: () => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            color={FORTA_BLUE.primary}
            sx={{ mr: 1, fontWeight: '700', fontSize: '16px', lineHeight: '24px' }}
          >
            Session ID
          </Typography>
          <TableSortIcon />
        </Box>
      ),
    },
  },
  {
    name: 'bcba',
    label: 'BCBA',
    options: {
      filter: false,
      sort: true,
      customHeadLabelRender: () => (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            color={FORTA_BLUE.primary}
            sx={{ mr: 1, fontWeight: '700', fontSize: '16px', lineHeight: '24px' }}
          >
            BCBA
          </Typography>
          <TableSortIcon />
        </Box>
      ),
    },
  },
];

export const claimProcedureTableColDefs = [
  {
    name: 'service_code',
    label: 'Service code',
    options: {
      filter: false,
      sort: false,
      display: false,
    },
  },
  {
    name: 'date',
    label: 'Date',
    options: {
      filter: false,
      sort: false,
      customHeadLabelRender: () => (
        <Typography
          color={FORTA_BLUE.primary}
          sx={{ mr: 1, fontWeight: '700', fontSize: '16px', lineHeight: '24px' }}
        >
          Date
        </Typography>
      ),
    },
  },
  {
    name: 'id',
    label: 'Session ID',
    options: {
      filter: false,
      sort: false,
      customBodyRender: (value: string, tableMeta: any) => {
        const { rowData } = tableMeta;
        const [code, _date, id] = rowData;
        return (
          <Typography
            sx={{
              '&:hover': { cursor: 'pointer' },
              textDecoration: 'underline',
              textAlign: 'right',
            }}
            color={FORTA_BLUE.primary}
            onClick={() => {
              history.navigate(getNavigateUrlForProcedures(code, id));
            }}
          >
            {formatSessionId(code, id)}
          </Typography>
        );
      },
      customHeadLabelRender: () => (
        <Typography
          color={FORTA_BLUE.primary}
          sx={{
            fontWeight: '700',
            padding: 0,
            fontSize: '16px',
            lineHeight: '24px',
            textAlign: 'right',
          }}
        >
          Session ID
        </Typography>
      ),
    },
  },
];
